
import { ref } from "@vue/runtime-core";
import { disableBodyOverflow, enableBodyOverflow } from "../mixins";
import { defineComponent, PropType } from "vue";
import { Content } from "../../views/content/helpers";
import VideoPlayButton from "./buttons/VideoPlay.vue";
import ModalIntroductoryContent from "./ModalIntroductoryContent.vue";

export default defineComponent({
  name: "FakeIframe",
  components: { ModalIntroductoryContent, VideoPlayButton },
  props: {
    introductoryContent: {
      type: Object as PropType<Content>
    }
  },

  setup() {
    const isIntroductoryContentModalOpen = ref(false);

    const openIntroductoryContent = (): void => {
      isIntroductoryContentModalOpen.value = true;
      disableBodyOverflow();
    };

    const closeModalIntroductoryContent = (): void => {
      isIntroductoryContentModalOpen.value = false;
      enableBodyOverflow();
    };

    return {
      isIntroductoryContentModalOpen,
      closeModalIntroductoryContent,
      openIntroductoryContent
    };
  }
});
